<template>
  <div class="login">
    <v-app>
      <Header :isPublic="true" />
      <v-main>
        <v-row justify="center" style="margin-top: 170px; margin-bottom: 60px">
        <v-col cols="12" md="4">
          <v-card>
            <v-toolbar color="#e6e6e6"
              >
              <v-img
                style="margin: auto"
                max-height="150"
                max-width="290"
                src="@/assets/logo_diario.png"
              ></v-img>
            </v-toolbar>
            <v-form v-model="valid" lazy-validation ref="form">
              <v-row style="margin: 20px">
                <v-col cols="12">
                  <v-text-field
                    v-model="user.username"
                    v-on:keyup.enter="handleLogin()"
                    label="Login"
                    prepend-icon="fa-user"
                    required
                    :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="user.password"
                    v-on:keyup.enter="handleLogin()"
                    type="password"
                    label="Senha"
                    required
                    prepend-icon="fa-key"
                    :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                  />
                </v-col>

                <v-col cols="12">
                  <v-btn color="primary" block @click="handleLogin()"
                    >Acessar</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-col>
      </v-row>

        </v-main>
      <v-footer fixed>
        <v-col class="text-center" cols="12"
          >2021 ©Copyright TCE-MA - Todos os Direitos Reservados</v-col
        >
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import Header from "@/components/template/Header.vue";
import User from "@/model/user";
export default {
  components: {
    Header
  },
  data() {
    return {
      user: new User("", ""),
      message: "",
      loading: false,
      valid: false,
    };
  },
  methods: {
    handleLogin() {
      this.loading = true;
      this.valid = this.$refs.form.validate();

      if (!this.valid) {
        this.loading = false;
        return;
      } else {
        if (this.user.username && this.user.password) {
          this.$store.dispatch("auth/login", this.user).then(
            () => {
              this.$router.push("/home");
            },
             (error) => {
              this.loading = false;
              this.message = (error.response && error.response.data && error.response.data.erro) 
                                ? error.response.data.erro 
                                : "Erro: Credenciais inválidas!";
                alert(this.message);
            } 
          )/* .catch((err) => {
            console.error(err.response);
            alert(err.response.data.message)
          }); */
        }
      }
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/home");
    }
  },
};
</script>

<style>
</style>